const USER_SUBSCRIPTION_REQUEST = 'USER_SUBSCRIPTION_REQUEST';
const USER_SUBSCRIPTION_SUCCESS = 'USER_SUBSCRIPTION_SUCCESS';
const USER_SUBSCRIPTION_FAILURE = 'USER_SUBSCRIPTION_FAILURE';

export {
  USER_SUBSCRIPTION_REQUEST,
  USER_SUBSCRIPTION_SUCCESS,
  USER_SUBSCRIPTION_FAILURE,
};
